import { Button, MessagePanel } from '@portal/components'
import paths from 'paths/link'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppManagementContext } from 'scenes/appManagement/context'

import DeleteAppModal from './DeleteAppModal'

/** Determines the redirection path based on the existence of a user ID or organization slug
 in the current pathname. */
const getRedirectionPath = (
  userId: string | null,
  organizationSlug: string | undefined,
) => {
  if (!!userId) {
    return paths.userApps({ userId })
  }

  if (!!organizationSlug) {
    return paths.organizationManagement({ slug: organizationSlug })
  }

  return paths.gettingStarted()
}

const DeleteAppSection = () => {
  const { appId } = useAppManagementContext()
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const navigate = useNavigate()
  const params = useParams<{ userId: string; organizationSlug: string }>()

  return (
    <div>
      <DeleteAppModal
        isOpen={showConfirmationModal}
        onClose={(shouldRedirect) => {
          if (shouldRedirect) {
            navigate(
              getRedirectionPath(params.userId!, params.organizationSlug),
              { replace: true },
            )
          } else {
            setShowConfirmationModal(false)
          }
        }}
        appId={appId}
      />
      <h3 className="text-lg font-medium leading-6 text-foreground-normal">
        Delete app
      </h3>
      <p className="mt-1 text-base text-foreground-subtle">
        Permanently delete your app and all associated data
      </p>
      <MessagePanel
        variant="danger"
        message={() => (
          <>
            Deleting an app permanently destroys any data related to it. This
            action is <span className="font-medium">not reversible</span>, so
            please double check the details and proceed with caution.
          </>
        )}
        className="mt-4 max-w-xl"
      />
      <Button
        variant="critical"
        className="mt-8"
        onClick={() => setShowConfirmationModal(true)}
        data-testid="deleteApp"
      >
        Delete app
      </Button>
    </div>
  )
}

export default DeleteAppSection
